import { If } from 'cdui-js';
import { pState } from '../store';
import { PreparePage } from './PreparePage';
import { OnlineProgress } from './OnlineProgress';

export const OnLine = () => {
  return (
    <>
      <If when={pState.current === 1}>
        <PreparePage />
      </If>
      <If when={pState.current > 1}>
        <OnlineProgress />
      </If>
    </>
  );
};
